import axios, { AxiosResponse } from "axios";
import { SERVERURL } from "../Globals/Constants";
import { Profile } from "../Models/Profile";
import { Expo } from "../Models/Expo";
import { ExpoDto } from "../Models/ExpoDto";

export const getAllExpos = async () => {
  const { data } = await axios.get<Expo[]>(`${SERVERURL}/api/expo/getall`, {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });

  return data;
};

export const getExpo = async (user: Profile, expoId: number) => {
  const { data } = await axios.get<Expo>(`${SERVERURL}/api/expo/get/${expoId}`, {
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json;charset=UTF-8",
    },
  });

  return data;
};

export const createExpo = async (
  user: Profile,
  expo: ExpoDto
): Promise<number> => {
  try {
    const formData = new FormData();

    formData.append("title", expo.title);
    formData.append("time", expo.time);
    formData.append("location", expo.location);
    formData.append("info", expo.info);

    if (expo.files && expo.files.length > 0) {
      expo.files.forEach((file) => formData.append("files", file));
    }

    const response: AxiosResponse = await axios.post(
      `${SERVERURL}/api/expo/create`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    );

    return response.status;
  } catch (error: any) {
    if (error.response) return error.response.status;
    else return Promise.reject(error.message);
  }
};

export const addFilesToExpo = async (
  user: Profile,
  expoId: number,
  files: File[]
): Promise<number> => {
  try {
    const formData = new FormData();
    if (!files || files.length === 0) throw new Error("No files provided");

    files.forEach((file) => formData.append("files", file));

    const response: AxiosResponse = await axios.post(
      `${SERVERURL}/api/expo/${expoId}/addFiles`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.status;
  } catch (error: any) {
    if (error.response) return error.response.status;
    else return Promise.reject(error.message);
  }
};

export const removeExpoFile = async (
  user: Profile,
  expoId: number,
  fileId: number
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.delete(
      `${SERVERURL}/api/expo/${expoId}/removeFile/${fileId}`,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    );

    return response.status;
  } catch (error: any) {
    if (error.response) return error.response.status;
    else return Promise.reject(error.message);
  }
};

export const updateExpo = async (
  user: Profile,
  expo: Partial<ExpoDto>,
  expoId: number
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.put(
      `${SERVERURL}/api/expo/update/${expoId}`,
      expo,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) return error.response.status;
    else return Promise.reject(error.message);
  }
};

export const deleteExpo = async (
  user: Profile,
  expoId: number
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.delete(
      `${SERVERURL}/api/expo/remove/${expoId}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );

    return response.status;
  } catch (error: any) {
    if (error.response) return error.response.status;
    else return Promise.reject(error.message);
  }
};
